import { defineMessages } from 'react-intl'

export default defineMessages({
  members: {
    id: 'FieldResult.Members.Suffix',
    defaultMessage: '({count} Members)'
  }
})
